import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import DocumentHeadView from './document-head-view.jsx';
import initSlugs from './slugs.js';

import SCHEMA from './seo.schema.yaml';

class SEOFeature extends AbstractFeature {
    get name() {
        return 'SEO';
    }

    get configSchema() {
        return SCHEMA;
    }

    get openGraphImages() {
        const images = this.config.openGraphImages;

        return Array.isArray(images) ? images : [images];
    }

    get meta() {
        return this.config.meta;
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            DocumentHead: {
                enable: this.config.enabled,
            },
        });
        super.updateViewsConfig(viewsConfig);
    }

    updateMojitoConfig(mojitoConfig) {
        const documentHead = ensureHierarchy(mojitoConfig, 'services.viewImplementations.DocumentHead');
        documentHead.implementation = DocumentHeadView;

        super.updateMojitoConfig(mojitoConfig);
    }

    beforeMojito() {
        if (this.config.urlSlug.enabled) {
            initSlugs();
        }

        return super.beforeMojito();
    }

    afterMojito() {
        setTimeout(() => {
            window.prerenderReady = true; // tell Prerender.io to snapshot after everything is initialized
        }, 10000);

        return super.afterMojito();
    }
}

export const SEO = new SEOFeature(allFeatures);
